module.exports = __webpack_public_path__ + "img/490.5ea798df.jpg";